module.exports = __webpack_public_path__ + "img/img23.c3a0cd37.png";